// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"163":"Popup-next","195":"Popupv2","508":"Embed-next","666":"Embed","855":"Popup"}[chunkId] || chunkId) + "." + {"155":"1af01a9e","163":"c9b765f4","183":"579d0b97","195":"f8f9d66e","508":"295903f5","509":"efb09b50","576":"6f5686d1","591":"f9485e21","666":"c8b58ff1","855":"bdb710eb"}[chunkId] + ".chunk.js";
};